/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SettingsPracticePermissions } from './settingsPracticePermissions';
import { SettingsThemePermissions } from './settingsThemePermissions';
import { SettingsAdministrativeDivisionPermissions } from './settingsAdministrativeDivisionPermissions';
import { SettingsTherapistProfilePermissions } from './settingsTherapistProfilePermissions';
import { SettingsPatientOpsTeamPermissions } from './settingsPatientOpsTeamPermissions';
import { SettingsTreatmentTopicPermissions } from './settingsTreatmentTopicPermissions';
import { SettingsOrganizationPermissions } from './settingsOrganizationPermissions';
import { SettingsTreatmentApproachPermissions } from './settingsTreatmentApproachPermissions';
import { SettingsPatientOpsProfilePermissions } from './settingsPatientOpsProfilePermissions';
import { SettingsTextSnippetPermissions } from './settingsTextSnippetPermissions';
import { SettingsPatientConcernPermissions } from './settingsPatientConcernPermissions';
import { SettingsTextSnippetTagPermissions } from './settingsTextSnippetTagPermissions';


import {ValidatorFn, Validators} from "@angular/forms";

export interface SettingsPermissions { 
    administrativeDivision: SettingsAdministrativeDivisionPermissions;
    organization: SettingsOrganizationPermissions;
    patientConcern: SettingsPatientConcernPermissions;
    patientOpsProfile: SettingsPatientOpsProfilePermissions;
    patientOpsTeam: SettingsPatientOpsTeamPermissions;
    practice: SettingsPracticePermissions;
    textSnippet: SettingsTextSnippetPermissions;
    textSnippetTag: SettingsTextSnippetTagPermissions;
    theme: SettingsThemePermissions;
    therapistProfile: SettingsTherapistProfilePermissions;
    treatmentApproach: SettingsTreatmentApproachPermissions;
    treatmentTopic: SettingsTreatmentTopicPermissions;
}
export const SettingsPermissions_administrativeDivision_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_organization_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_patientConcern_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_patientOpsProfile_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_patientOpsTeam_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_practice_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_textSnippet_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_textSnippetTag_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_theme_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_therapistProfile_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_treatmentApproach_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsPermissions_treatmentTopic_Validators: ValidatorFn[] =
    [  Validators.required, ];


